<template>
  <!--
        作者：gmshop
        时间：2020-06-08
        描述：超链接选择-页面
    -->
    <el-select v-model="activePage" placeholder="请选择" class="percent-w100" @change="changeFunc" value-key="url">
        <el-option v-for="item in pages" :key="item.url" :value-key="item.name" :label="item.name" :value="item"></el-option>
    </el-select>
</template>

<script>
    export default{
        data(){
            return {
                /*页面数据*/
                pages: [
                    {
                        url: 'pages/index/index',
                        name: '首页',
                        type: '页面'
                    },
                    // {
                    //     url: 'pages/product/category',
                    //     name: '分类',
                    //     type: '页面'
                    // },
                    // {
                    //     url: 'pages/cart/cart',
                    //     name: '购物车',
                    //     type: '页面',
                    // },
                    {
                        url: 'pages/user/index/index',
                        name: '我的',
                        type: '页面',
                    },
                    // {
                    //     url: 'pages/agent/index/index',
                    //     name: '分销中心',
                    //     type: '页面',
                    // },
                    {
                        url: 'pages/user/address/address',
                        name: '收货地址',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/set/set',
                        name: '设置',
                        type: '页面',
                    },
                    // {
                    //     url: 'pages/user/my-coupon/my-coupon',
                    //     name: '我的优惠券',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/article/list/list',
                    //     name: '文章首页',
                    //     type: '页面',
                    // },
                    // {
                    //     url: 'pages/plus/giftpackage/giftlist',
                    //     name: '我的礼包',
                    //     type: '页面',
                    // },
                    {
                        url: 'pages/rank/rank',
                        name: '个人排行榜',
                        type: '页面',
                    },
                    // {
                    //     url: 'pages/index/msg',
                    //     name: '消息',
                    //     type: '页面',
                    // },
                    {
                        url: 'subpackage/event/list?task_type=10',
                        name: '单人活动',
                        type: '页面',
                    },
                    {
                        url: 'subpackage/event/list?task_type=20',
                        name: '团队活动',
                        type: '页面',
                    },
                    {
                        url: 'pages/index/dati',
                        name: '答题',
                        type: '页面',
                    },
                    {
                        url: 'pages/news/news',
                        name: '消息通知',
                        type: '页面',
                    },
                    {
                        url: 'subpackage/myActive/myActive',
                        name: '我的活动',
                        type: '页面',
                    },
                    {
                        url: 'pages/user/set/updateinfo',
                        name: '修改资料',
                        type: '页面',
                    },
                    {
                        url: 'subpackage/event/topic/index',
                        name: '答题',
                        type: '页面',
                    },
                ],
                /*选中的值*/
                activePage: '首页'
            }
        },
        created() {
          /*初始化*/
          this.changeFunc(this.pages[0]);
        },
        methods: {
            /*选中的值*/
            changeFunc(e){
                this.$emit('changeData', e);
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Pages.vue